import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_vuesocialsharingplugin_622680ac from 'nuxt_plugin_vuesocialsharingplugin_622680ac' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_templatesplugin8e90e0b0_adf041b4 from 'nuxt_plugin_templatesplugin8e90e0b0_adf041b4' // Source: ./templates.plugin.8e90e0b0.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_11afb6db from 'nuxt_plugin_cookieuniversalnuxt_11afb6db' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_recaptcha_7a9d9a22 from 'nuxt_plugin_recaptcha_7a9d9a22' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_5638dd33 from 'nuxt_plugin_axios_5638dd33' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_adb5566e from 'nuxt_plugin_gtm_adb5566e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_moment_7f8e5ac5 from 'nuxt_plugin_moment_7f8e5ac5' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_bus_5e46274a from 'nuxt_plugin_bus_5e46274a' // Source: ../plugins/bus (mode: 'all')
import nuxt_plugin_apis_6a7e3a0f from 'nuxt_plugin_apis_6a7e3a0f' // Source: ../plugins/apis (mode: 'all')
import nuxt_plugin_contentful_cbbecb4c from 'nuxt_plugin_contentful_cbbecb4c' // Source: ../plugins/contentful (mode: 'all')
import nuxt_plugin_debug_352396c6 from 'nuxt_plugin_debug_352396c6' // Source: ../plugins/debug (mode: 'all')
import nuxt_plugin_elements_1acff326 from 'nuxt_plugin_elements_1acff326' // Source: ../plugins/elements (mode: 'all')
import nuxt_plugin_directives_d0867c0c from 'nuxt_plugin_directives_d0867c0c' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_formatters_c491ae42 from 'nuxt_plugin_formatters_c491ae42' // Source: ../plugins/formatters (mode: 'all')
import nuxt_plugin_links_343e23fa from 'nuxt_plugin_links_343e23fa' // Source: ../plugins/links (mode: 'all')
import nuxt_plugin_seo_5e466527 from 'nuxt_plugin_seo_5e466527' // Source: ../plugins/seo (mode: 'all')
import nuxt_plugin_validators_f079c152 from 'nuxt_plugin_validators_f079c152' // Source: ../plugins/validators (mode: 'all')
import nuxt_plugin_googlemaps_ab35f716 from 'nuxt_plugin_googlemaps_ab35f716' // Source: ../plugins/google-maps (mode: 'all')
import nuxt_plugin_amplitudeclient_578f2653 from 'nuxt_plugin_amplitudeclient_578f2653' // Source: ../plugins/client/amplitude.client.js (mode: 'client')
import nuxt_plugin_rumclient_790655cc from 'nuxt_plugin_rumclient_790655cc' // Source: ../plugins/client/rum.client.js (mode: 'client')
import nuxt_plugin_dialogsclient_6dd3ef0a from 'nuxt_plugin_dialogsclient_6dd3ef0a' // Source: ../plugins/client/dialogs.client.js (mode: 'client')
import nuxt_plugin_persistclient_ece45238 from 'nuxt_plugin_persistclient_ece45238' // Source: ../plugins/client/persist.client.js (mode: 'client')
import nuxt_plugin_utilitiesclient_db73f7cc from 'nuxt_plugin_utilitiesclient_db73f7cc' // Source: ../plugins/client/utilities.client.js (mode: 'client')
import nuxt_plugin_actioncableclient_fdf47fd2 from 'nuxt_plugin_actioncableclient_fdf47fd2' // Source: ../plugins/client/actioncable.client.js (mode: 'client')
import nuxt_plugin_workflowclient_94deae2a from 'nuxt_plugin_workflowclient_94deae2a' // Source: ../plugins/client/workflow.client.js (mode: 'client')
import nuxt_plugin_elementsclient_02a527ba from 'nuxt_plugin_elementsclient_02a527ba' // Source: ../plugins/client/elements.client.js (mode: 'client')
import nuxt_plugin_chartsclient_fec244fe from 'nuxt_plugin_chartsclient_fec244fe' // Source: ../plugins/client/charts.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"titleTemplate":"%s - Pod | Online Distribution Platform for Emerging Brands","title":"Welcome","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"theme-color","content":"#9b0b54"},{"hid":"site_name","property":"og:site_name","content":"Pod"},{"hid":"og:title","property":"og:title","content":"Pod | Online Distribution Platform for Emerging Brands"},{"hid":"description","name":"description","content":"Pod is a revolutionary B2B distribution platform that connects emerging food brands with grocery buyers."},{"hid":"og:description","property":"og:description","content":"Pod is a revolutionary B2B distribution platform that connects emerging food brands with grocery buyers."},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fappbeta.podfoods.co\u002Fog.jpg"},{"hid":"og:image:type","property":"og:image:type","content":"image\u002Fjpeg"},{"hid":"og:locale","property":"og:locale","content":"en_US"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ficon.png?pod"},{"rel":"shortcut icon","type":"image\u002Fpng","href":"\u002Ficon.png?pod"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_vuesocialsharingplugin_622680ac === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_622680ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin8e90e0b0_adf041b4 === 'function') {
    await nuxt_plugin_templatesplugin8e90e0b0_adf041b4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_11afb6db === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_11afb6db(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_7a9d9a22 === 'function') {
    await nuxt_plugin_recaptcha_7a9d9a22(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5638dd33 === 'function') {
    await nuxt_plugin_axios_5638dd33(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_adb5566e === 'function') {
    await nuxt_plugin_gtm_adb5566e(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_7f8e5ac5 === 'function') {
    await nuxt_plugin_moment_7f8e5ac5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_bus_5e46274a === 'function') {
    await nuxt_plugin_bus_5e46274a(app.context, inject)
  }

  if (typeof nuxt_plugin_apis_6a7e3a0f === 'function') {
    await nuxt_plugin_apis_6a7e3a0f(app.context, inject)
  }

  if (typeof nuxt_plugin_contentful_cbbecb4c === 'function') {
    await nuxt_plugin_contentful_cbbecb4c(app.context, inject)
  }

  if (typeof nuxt_plugin_debug_352396c6 === 'function') {
    await nuxt_plugin_debug_352396c6(app.context, inject)
  }

  if (typeof nuxt_plugin_elements_1acff326 === 'function') {
    await nuxt_plugin_elements_1acff326(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_d0867c0c === 'function') {
    await nuxt_plugin_directives_d0867c0c(app.context, inject)
  }

  if (typeof nuxt_plugin_formatters_c491ae42 === 'function') {
    await nuxt_plugin_formatters_c491ae42(app.context, inject)
  }

  if (typeof nuxt_plugin_links_343e23fa === 'function') {
    await nuxt_plugin_links_343e23fa(app.context, inject)
  }

  if (typeof nuxt_plugin_seo_5e466527 === 'function') {
    await nuxt_plugin_seo_5e466527(app.context, inject)
  }

  if (typeof nuxt_plugin_validators_f079c152 === 'function') {
    await nuxt_plugin_validators_f079c152(app.context, inject)
  }

  if (typeof nuxt_plugin_googlemaps_ab35f716 === 'function') {
    await nuxt_plugin_googlemaps_ab35f716(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amplitudeclient_578f2653 === 'function') {
    await nuxt_plugin_amplitudeclient_578f2653(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rumclient_790655cc === 'function') {
    await nuxt_plugin_rumclient_790655cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dialogsclient_6dd3ef0a === 'function') {
    await nuxt_plugin_dialogsclient_6dd3ef0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistclient_ece45238 === 'function') {
    await nuxt_plugin_persistclient_ece45238(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_utilitiesclient_db73f7cc === 'function') {
    await nuxt_plugin_utilitiesclient_db73f7cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_actioncableclient_fdf47fd2 === 'function') {
    await nuxt_plugin_actioncableclient_fdf47fd2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workflowclient_94deae2a === 'function') {
    await nuxt_plugin_workflowclient_94deae2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_elementsclient_02a527ba === 'function') {
    await nuxt_plugin_elementsclient_02a527ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chartsclient_fec244fe === 'function') {
    await nuxt_plugin_chartsclient_fec244fe(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
